<template>
  <div class="my-1 card">
    <div class="my-0 py-1 card-header text-info">
      <h4 class="my-0 py-1">
        <span v-if="!this.$store.getters.amendmentMode">Sow Details</span>
        <span v-if="this.$store.getters.amendmentMode">
          {{
            this.$store.getters.selectedIncidentType == "it-mdr"
              ? "Renewal Contract"
              : "SoW Amendment"
          }}
          Details</span
        >
      </h4>
    </div>
    <div class="card-body" >
      <div v-if="sowDetails">
      <h4>
        <span
          v-if="!this.$store.getters.amendmentMode && sowDetails.sowFileInfo"
          >SoW Generated successfully!</span
        >
        <span
          v-if="
            this.$store.getters.amendmentMode && sowDetails.amendmentFileInfo
          "
        >
          {{
            this.$store.getters.selectedIncidentType == "it-mdr"
              ? "Renewal Contract"
              : "SoW Amendment"
          }}
          Generated successfully!</span
        >
        <span
          v-if="!this.$store.getters.amendmentMode && sowDetails.sowFileInfo"
        >
          <a target="_blank" :href="sowDetails.sowFileInfo.webURl">
            <span v-if="!this.$store.getters.amendmentMode"
              >View SoW&nbsp;</span
            >
          </a>
        </span>
        <span
          v-if="
            this.$store.getters.amendmentMode && sowDetails.amendmentFileInfo
          "
        >
          <a target="_blank" :href="sowDetails.amendmentFileInfo.webURl">
            <span v-if="this.$store.getters.amendmentMode"
              >View
              {{
                this.$store.getters.selectedIncidentType == "it-mdr"
                  ? "Renewal Contract"
                  : "SoW Amendment"
              }}</span
            >
          </a>
        </span>
        <span
          v-if="!this.$store.getters.amendmentMode && sowDetails.msaFileInfo"
        >
          <a target="_blank" :href="sowDetails.msaFileInfo.webURl">
            <span v-if="!this.$store.getters.amendmentMode">View MSA</span>
          </a>
        </span>
      </h4>
    </div>
    <div v-if="!sowDetails">
      <h4>
        <span v-if="!this.$store.getters.amendmentMode"
          >SoW Generation Failed!</span
        >
        <span v-if="this.$store.getters.amendmentMode"
          >          {{
            this.$store.getters.selectedIncidentType == "it-mdr"
              ? "Renewal Contract"
              : "SoW Amendment"
          }} Generation Failed!</span
        >
      </h4>
      <h6 v-if="errorMsg != ''" class="error">
        Not able to create document. Message: "{{ errorMsg }}"
      </h6>
    </div>
      <button class="btn btn-secondary" @click="goback">Generate Again</button>
      <button
        class="btn btn-info mx-2"
        v-bind:disabled="nextable"
        @click="gonext"
      >
        Generate New
      </button>
      <router-link
        :to="sowsPath"
        v-if="sowDetails"
        para
        class="text-info"
        >View SoWs</router-link
      >
    </div>
  </div>
</template>

<script>
import serviceProxy from "../services/index";
import _ from "lodash";
import Vue from "vue";

export default {
  name: "GenerateSoW",
  beforeMount() {
    var that = this;
    that.$root.$emit("stage", 5);

    /*
        1. Create the SoWData Object needed by the controller
            1. PlaceHolders
            2. Token
            3. ServicesData
                1. Tasks
                2.  Scope
                3. Title
                4. Description
                5. Code
      */

    /*
          1. Get the selected services
          2. 
      */
    let placeHolderValues = this.$store.getters.placeholderValues;
    let token = this.$store.getters.token;
    let servicesData = this.$store.getters.servicesData;
    let selectedServices = this.$store.getters.selectedServices;
    let amendmentMode = this.$store.getters.amendmentMode;
    let sowSlug = this.$store.getters.soWSlug;
    var sowData = {};
    sowData.PlaceHolders = _.map(placeHolderValues, (ph) => {
      return {
        Name: ph.slug,
        Value: ph.Value,
      };
    });
    let servicesMasterRecord = that.$store.getters.masterData.services;
    sowData.Token = token;
    sowData.SowFileInfo =
      that.$store.getters.selectedMasterTemplateConfig.sowFileInfo;
    sowData.MSAFileInfo =
      that.$store.getters.selectedMasterTemplateConfig.msaFileInfo;
    sowData.AmendmentFileInfo =
      that.$store.getters.selectedMasterTemplateConfig.amendmentFileInfo;
    sowData.ServicesOverview =
      that.$store.getters.selectedMasterTemplateConfig.serviceOverview;
    sowData.Lawfirm = that.$store.getters.selectedLawfirm;
    sowData.SubOfferingType = that.$store.getters.selectedSubofferingType;
    sowData.IncidentType = that.$store.getters.selectedIncidentType;
    sowData.IncidentTypeTitle = that.$store.getters.selectedIncidentTypeTitle;
    sowData.SubofferingTypeTitle =
      that.$store.getters.selectedSubofferingTypeTitle;
    sowData.LawfirmTitle = that.$store.getters.selectedLawfirmTitle;
    sowData.Authority = that.$store.getters.selectedAuthority[0];
    let currentIncidentType = _.filter(
      that.$store.getters.masterData.incidentTypes,
      (mr) => mr.slug == that.$store.getters.selectedIncidentType
    );
    sowData.NotificationEmail = currentIncidentType[0].notificationEmail
      ? currentIncidentType[0].notificationEmail
      : null;
    if (that.$store.getters.selectedProject != null) {
      sowData.MavenlinkId = that.$store.getters.selectedProject.id;
      sowData.CurrencyType = that.$store.getters.selectedProject.currency;
      sowData.CurrencySymbol =
        that.$store.getters.selectedProject.currency_symbol;
      sowData.RateCardId = that.$store.getters.selectedProject.rate_card_id
        ? that.$store.getters.selectedProject.rate_card_id
        : 0;
      var carrierdetails = _.find(
        that.$store.getters.selectedProject.custom_field_values,
        (selser) => selser.custom_field_id === this.carrierId
      );
      sowData.Carrier = carrierdetails ? carrierdetails.display_value : "";
    } else if (that.$store.getters.newClientRateCardData) {
      let currency = this.countryCurrency();
      sowData.CurrencySymbol = currency[0].Symbol;
      sowData.CurrencyType = currency[0].Code;
      sowData.RateCardId = that.$store.getters.newClientRateCardData.rateCardId;
      sowData.Carrier = that.$store.getters.newClientRateCardData.carrier;
      sowData.SubOfferingType = that.$store.getters.selectedSubofferingType;
      sowData.IncidentType = that.$store.getters.selectedIncidentType;
      sowData.Country = this.$store.getters.selectedCountry;
    }
    sowData.RateCardDetails = that.$store.getters.rateCardsDetails;
    if (that.$store.getters.rateCardsDetails) {
      let rateCardTitle =
        that.$store.getters.rateCardsDetails.rateCardTitle.toLowerCase();
      let carrier = sowData.Carrier.toLowerCase();
      sowData.IsTravelers =
        rateCardTitle.includes("traveler") && carrier.includes("traveler")
          ? true
          : false;
    } 
    if (this.$store.getters.selectedIncidentType == "it-inv" && sowData.Carrier) {
      let carrier = sowData.Carrier.toLowerCase();
      sowData.IsTravelers = carrier.includes("traveler") ? true : false;
    }
    sowData.HubSpotCompanyId = that.$store.getters.selectedClient.companyId;
    sowData.Country = this.$store.getters.selectedCountry;
    if (sowData.ServicesOverview) {
      sowData.ServicesOverview.items = _.filter(
        that.$store.getters.selectedMasterTemplateConfig.serviceOverview.items,
        (mr) => mr.isActive == true
      );
    } else {
      sowData.ServicesOverview = {};
    }
    sowData.Services = _.map(servicesData, (serviceData) => {
      var serviceConfig = _.find(selectedServices, (selService) => {
        return selService.slug === serviceData.servicecode;
      }).serviceConfig;
      let serviceMasterRecord = _.find(servicesMasterRecord, (smr) => {
        return smr.slug === serviceData.servicecode;
      });
      let activeTasks = _.filter(serviceData.Tasks, (t) => t.isActive);
      let tasks = _.map(activeTasks, (serviceTask) => {
        let items = [];
        let activeitems = _.filter(serviceTask.items, (t) => t.isActive);
        if (activeitems && activeitems.length > 0) {
          items = _.map(activeitems, (serviceTaskItem) => {
            let childitems = [];
            if (
              serviceTaskItem.items &&
              serviceTaskItem.items.length > 0 &&
              serviceData.servicecode != "svc-dat-bre-ana-pha-2" &&
              serviceData.servicecode != "svc-dat-bre-ana-pha-1"
            ) {
              childitems = _.map(
                serviceTaskItem.items,
                (serviceTaskChildItem) => {
                  return {
                    Code: serviceTaskChildItem.slug,
                    Description: serviceTaskChildItem.description,
                    Title: serviceTaskChildItem.title,
                    Items: serviceTaskChildItem.items,
                  };
                }
              );
            }
            return {
              Code: serviceTaskItem.slug,
              Description: serviceTaskItem.description,
              Title: serviceTaskItem.title,
              Items:
                serviceData.servicecode != "svc-dat-bre-ana-pha-2" &&
                serviceData.servicecode != "svc-dat-bre-ana-pha-1"
                  ? serviceTaskItem.items
                  : _.filter(serviceTaskItem.items, (x) => x.IsSelected), // Need to test
            };
          });
        }
        return {
          Code: serviceTask.slug,
          Description: serviceTask.description,
          Title: serviceTask.title,
          Items: items,
        };
      });
      let serviceOverview = serviceData.ServiceOverview;

      let preSections = [];
      if (serviceData.PreSections && serviceData.PreSections.length > 0) {
        preSections = _.map(serviceData.PreSections, (section) => {
          return {
            Code: section.slug,
            Description: section.description,
            Title: section.title,
          };
        });
      }
      let postSections = [];
      if (serviceData.PostSections && serviceData.PostSections.length > 0) {
        postSections = _.map(serviceData.PostSections, (section) => {
          return {
            Code: section.slug,
            Description: section.description,
            Title: section.title,
          };
        });
      }
      console.log(serviceData.Scopes);
      var shouldBeRenderedScopes = _.filter(serviceData.Scopes, (scope) => {
        var curScope = _.find(
          serviceConfig.scopes,
          (configScope) => configScope.slug === scope.slug
        );
        return !curScope.shouldBeHidden;
      });
      console.log(shouldBeRenderedScopes);
      let scopes = _.map(shouldBeRenderedScopes, (serviceScope) => {
        return {
          Code: serviceScope.slug,
          Description: serviceScope.description,
          Inputs: serviceScope.inputs,
        };
      });
      let addnlScopes = _.filter(
        serviceData.AdditionalScopes,
        (scope) => scope.isActive
      );
      addnlScopes = _.map(addnlScopes, (serviceScope) => {
        return {
          Code: serviceScope.slug,
          Description: serviceScope.description,
        };
      });
      scopes = _.union(scopes, addnlScopes);
      let serviceOverviewClone = null;
      if (serviceOverview) {
        serviceOverviewClone = { ...serviceOverview };
      }

      if (serviceData.isOptional && serviceOverviewClone) {
        for (let i = 0; i < serviceOverviewClone.Items.length; i++) {
          serviceOverviewClone.Items[i].Description = `If required, ${
            serviceData.servicecode != "svc-res-ser" &&
            serviceData.servicecode != "svc-ons-ser"
              ? this.lowerCaseFirstLetter(
                  serviceOverviewClone.Items[i].description
                )
              : serviceOverviewClone.Items[i].description
          }`;
        }
      }
      if (
        (serviceMasterRecord.Slug === "svc-ran-dec-val" ||
          serviceMasterRecord.Slug === "svc-ran-dec-val-mon") &&
        that.$store.getters.selectedLawfirm.indexOf("lf-nol-") > -1 &&
        serviceOverviewClone.Items
      ) {
        _.each(serviceOverviewClone.Items, (serviceSec) => {
          serviceSec.Description = serviceSec.description.replace(
            `and Counsel`,
            ``
          );
        });
      }
      return {
        Title: serviceData.isOptional
          ? "OPTIONAL - " + serviceMasterRecord.Title
          : serviceMasterRecord.Title,
        Code: serviceMasterRecord.slug,
        Description: serviceMasterRecord.Description,
        isOptional: serviceData.isOptional,
        HasSubTasks: serviceData.HasSubTasks,
        ServiceOrder: serviceData.ServiceOrder,
        //Phase: "Phase 1",
        ServiceOverview: serviceOverviewClone,
        Tasks: tasks,
        Scopes: scopes,
        PostSections: postSections,
        PreSections: preSections,
      };
    });

    //let carrier = that.$store.getters.selectedCarrier;
    let lawfirm = that.$store.getters.selectedLawfirm;

    sowData.State = JSON.parse(JSON.stringify(that.$store.getters.state));
    sowData.IsAmendment = amendmentMode;
    sowData.IsNewMDRRenewal = amendmentMode
      ? false
      : this.$store.getters.newMdrRenewal;
    sowData.SowSlug = sowSlug;
    var dataminigservice = _.find(
      sowData.State.selectedServices,
      (selService) => {
        if (selService.Slug === "svc-dat-bre-ana-pha-1") {
          return selService.Slug === "svc-dat-bre-ana-pha-1";
        } else if (selService.Slug === "svc-dat-bre-ana-pha-2") {
          return selService.Slug === "svc-dat-bre-ana-pha-2";
        }
      }
    );
    if (dataminigservice) {
      var specitype = _.find(
        dataminigservice.serviceConfig.Scopes,
        (specificationType) => {
          return specificationType.specType;
        }
      );
    }
    if (specitype) {
      let specTitle = specitype.specType;
      _.each(sowData.Services, (serviceSection) => {
        if (
          serviceSection.Code === "svc-dat-bre-ana-pha-2" ||
          "svc-dat-bre-ana-pha-1"
        ) {
          _.each(serviceSection.Tasks, (MTasks) => {
            if (MTasks.Items) {
              _.each(MTasks.Items, (TaskItems) => {
                TaskItems.Items = _.filter(
                  TaskItems.Items,
                  (ti) => ti.Title == specTitle
                );
              });
            }
          });
        }
      });
    }
    if (
      sowData.State.selectedIncidentType == "it-bus-ema-com" &&
      sowData.State.selectedLawfirm == "lf-bak"
    ) {
      _.each(sowData.Services, (serviceSec) => {
        if (serviceSec.Code == "svc-sec-val-mon-and-con") {
          serviceSec.ServiceOverview = {};
        }
      });
    }
    delete sowData.State.token;
    delete sowData.State.user;
    delete sowData.State.uaa;
    delete sowData.State.isAuthenticated;
    that.sowDetails = that.$store.getters.sowData;
    if (!that.sowDetails) {
      that.$root.$emit("progress");
      that.$root.$emit("toast", {
        title: "Creating SoW",
        message: "Knitting everything together to generate the SoW",
      });
      serviceProxy.sow
        .generateSoW(that.$store.getters.token, lawfirm, sowData)
        .then((data) => {
          that.sowDetails = data.data.data;
          this.$store.commit("sowData", that.sowDetails);
          //that.$store.commit("sowGenerated", that.sowDetails);
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: "SoW Generated",
            message:
              "SoW generated for the selected template and the given values",
          });
          //tjat.$store.commit("setCreateAgainMode", true);
          confetti.start();
          setTimeout(function () {
            confetti.stop();
          }, 3000);
        })
        .catch((e) => {
          console.log(e);
          that.errorMsg = "";
          that.errorMsg = e.response.data.error
            ? e.response.data.error.message
            : "Generation Failed";
          if (e.response.status == 401) {
            that.errorMsg = "Session Expired!";
          } else if (
            that.errorMsg
              .toLowerCase()
              .indexOf("the resource you are attempting to access is locked") !=
            -1
          ) {
            that.errorMsg =
              "The resource you are attempting to access is open some where. Please close the document and Generate Again.";
          } else if (
            that.errorMsg.toLowerCase().indexOf("accessdenied") != -1
          ) {
            that.errorMsg =
              "User doesn't have the sharepoint access to create SOW";
          }
          that.$root.$emit("toast", {
            title: "SoW Generation Failed",
            message: that.errorMsg,
          });
          that.$root.$emit("done");
        });
    }
  },
  props: {
    msg: String,
  },
  methods: {
    countryfilter(value) {
      let that = this;
      if (!value) {
        return "";
      }
      value = value.toString();
      let country = _.filter(
        that.$store.getters.masterData.countries,
        (lm) => lm.slug === value
      );
      return country[0].title;
    },
    goback: function (oEvent) {
      this.$store.commit("sowData", null);
      this.$router.go(-1);
    },
    gonext: function (oEvent) {
      this.$root.$emit("init");
      this.$router.replace({ path: "choose-document" });
    },
    lowerCaseFirstLetter: function (string) {
      return string.charAt(0).toLowerCase() + string.slice(1);
    },
    countryCurrency() {
      let country = this.countryfilter(this.$store.getters.selectedCountry);
      return Vue.countryCurrency(country);
    },
  },
  computed: {
    nextable() {
      return !(
        _.filter(this.placeHolders, (ph) => {
          return !(ph.DefaultValue !== null && ph.DefaultValue.trim() !== "");
        }).length === 0
      );
    },
  },
  data() {
    return {
      sowDetails: "",
      carrierId: parseInt(process.env.VUE_APP_carrierId),
      errorMsg: "",
      sowsPath: "/sows", ///" + this.$store.getters.selectedLawfirm
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
/* ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
} */
a {
  color: #42b983;
}
.error {
  color: red;
  border-color: #fdd;
}
</style>
